import { useState, useEffect } from 'react';
import { ReactSortable } from 'react-sortablejs';
import { MdDragIndicator } from 'react-icons/md';
import ManageVideos from './ManageVideos';
import { AiFillDelete } from 'react-icons/ai';
import { FiEdit } from 'react-icons/fi';
import useManageTopicVideos from 'hooks/API/useManageTopicVideos';
import { useParams } from 'react-router-dom';
import { ROLES } from 'utilities/constants';

function TopicVideoTab({ data, subtopicID, userContext }) {
  const { topicID } = useParams();
  const [videos, setVideos] = useState([]);
  const [videoEdit, setVideoEdit] = useState(null);

  const { userInfo = {} } = userContext;
  const isTeacher = userInfo?.data?.key === ROLES.TUTOR;

  useEffect(() => {
    setVideos(data?.videos);

    const currentSelectedVideo = data?.videos?.find?.((video) => video?._id === videoEdit?._id);

    if (currentSelectedVideo) {
      setVideoEdit(currentSelectedVideo);
    }
  }, [data?.videos, videoEdit?._id]);

  const { mutate, isLoading } = useManageTopicVideos({ topicID });

  function generateReOrderData() {
    if (isLoading) return;

    const order = videos.map((video, index) => ({ contentId: video._id, sortPosition: index }));

    // re-order if at least 2 items
    if (order?.length > 1) {
      mutate({ order, type: 'REORDER' });
    }
  }

  function deleteVideo(videoID) {
    if (isTeacher) return;
    if (isLoading) return;

    if (videoID === videoEdit?._id) setVideoEdit(null);

    mutate({ videoID, type: 'DELETE' });
  }

  return (
    <div className="container">
      {!isTeacher && (
        <ManageVideos
          subtopicID={subtopicID}
          data={data}
          editMode={videoEdit}
          toggle={() => setVideoEdit(null)}
        />
      )}

      <div className="row">
        <div className="col-12">
          <span className=" col-12  mt-5 mb-5 conaddtitle boldtitle">
            Uploaded Videos
            {/* {videos?.length > 1 && (
              <AppButton variantClass="btn-plane g--tint mx-4" onClick={generateReOrderData}>
                Save order
              </AppButton>
            )} */}
          </span>

          {videos?.length > 0 ? (
            <ReactSortable
              list={videos}
              setList={(list) => {
                if (!isTeacher) {
                  setVideos(list);
                }
              }}
              // handle=".videoGrabHandleID"
              handle=".nonExistingId"
              className="row my-4"
            >
              {videos?.map?.((list) => {
                return (
                  <div className="col-4" key={list.id || list._id} data-id={list.id || list._id}>
                    <div className="ratio ratio-21x9">
                      <video
                        width="320"
                        height="240"
                        controls
                        poster={list?.video?.thumbnailFullUrl}
                        id={`app-vi-${list.id || list._id}`}
                      >
                        <source src={list?.video?.link} type={list?.video?.contentType} />
                        Your browser does not support the video tag.
                      </video>
                      <div>
                        {!isTeacher && (
                          <>
                            <span className="mx-2" style={{ cursor: 'pointer' }}>
                              <MdDragIndicator className="videoGrabHandleID" />
                            </span>
                            <span
                              className="mx-2"
                              style={{ cursor: 'pointer' }}
                              onClick={() => setVideoEdit(list)}
                            >
                              <FiEdit className="text-info" />
                            </span>
                            <span
                              className="mx-2"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                if (window.confirm('Are you sure you want to delete?')) {
                                  deleteVideo(list._id);
                                }
                              }}
                            >
                              <AiFillDelete className="text-danger" />
                            </span>
                          </>
                        )}
                        <label className="videotitlename">
                          {list?.name || list?.originalFileName}
                        </label>
                      </div>
                    </div>
                  </div>
                );
              })}
            </ReactSortable>
          ) : (
            <div className="text-center">No videos found</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TopicVideoTab;
